<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true }">
    <div class="referral-heading" fxLayout="column">
      <sbnb-page-header [parentPath]="'/menu-mobile'">
        <div class="flex items-center justify-between">
          <h2 class="text-center m-0">Share your love for {{ 'CORE.PRODUCT_NAME' | transloco }}</h2>
        </div>
      </sbnb-page-header>

      <h4>
        $30 credit towards your next invoice for every host you refer and $30 credit towards their first invoice.
        Everybody wins!
      </h4>
    </div>

    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <span *ngIf="error">Failed to load Growsurf. You may need to disable adblocking to use this service.</span>

    <div *ngIf="!loading && !error" fxLayout="column" fxLayoutGap="40px">
      <div data-grsf-block-form id="growsurf-main-form"></div>

      <!-- <div data-grsf-block-rewards></div> -->

      <div data-grsf-block-invite></div>

      <!-- <div data-grsf-block-stats></div> -->

      <div data-grsf-block-referral-status></div>
    </div>
  </main>
</div>
